import React from 'react';

import Game from './Game';

import styles from '../styles/Playscreen.css';

export default (props) => {

  const idealHeight = window.innerWidth * 0.75;
  const height = window.innerHeight;
  const width = height < idealHeight ? height / 0.75 : window.innerWidth;

  const screenStyle = {
    width
  };

  const message = props.api.correctAnswers < props.api.wrongAnswers ? "Game Over" : "Well Done!";

  return (
    <div
        className={styles.ui}
        style={screenStyle}>
      <Game {...props} />
      { props.playState == "playing" &&
        <div>
          <div className={styles.question}>
            <p>{props.question}</p>
          </div>
          <div className={styles.answers}>
          {
            props.answers &&
              props.answers.map((a,i) => (
                <div
                    key={i}
                    className={`${styles.answer} ${styles[a.character]}`}
                    onClick={()=>{props.onAnswerClick(i)}}>
                  <p className="">{ a.text }</p>
                </div>
              ))
          }
          </div>
        </div>
      }
      <div className={styles.questionNumber}>
        {props.questionNumber+1}/{props.questionCount}
      </div>
      <div className={styles.scoreboard}>
        Score:{' '}
        {props.score}
      </div>
      { props.playState == "finished" &&
        <div className={styles.banner}>
          <h1 className={styles.bannerText}>{message}</h1>
        </div>
      }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/PlayScreen.js